// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vCQFCw,
.d20XCF {
  position: fixed;
  bottom: var(--spacing-3);
  right: var(--spacing-3);
  z-index: 1000;
  box-shadow: var(--shadow-xl);
  font-family: var(--font-family-base);
}

.vCQFCw {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: 0;
  border-radius: var(--radius-pill);
  color: var(--text-neutral-white);
  background: linear-gradient(135deg, var(--surface-primary-medium), var(--data-series-06));
  cursor: pointer;
}

.vCQFCw[hidden] {
  display: none;
}
.vCQFCw:focus-visible,
.Z854tH:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 3px;
}

.d20XCF {
  margin: 0;
  padding: 0;
  top: auto;
  left: auto;
  max-width: none;
  max-height: none;
  width: min(880px, calc(100vw - 48px));
  height: min(680px, calc(100dvh - 48px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-m);
  color: var(--text-neutral-dark);
  background: var(--surface-neutral-white);
}

.bFiumo {
  width: min(360px, calc(100vw - 48px));
  height: 56px;
}
.q1S3fM {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  min-height: 56px;
  padding: 0 var(--spacing-2);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  background: linear-gradient(90deg, var(--surface-tertiary-soft), var(--surface-neutral-white));
}

.q1S3fM h2 {
  flex: 1;
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}
.Ixg_XP {
  display: inline-flex;
  color: var(--surface-tertiary-strong);
}
.Z854tH {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: var(--radius-xs);
  color: var(--text-neutral-dark);
  background: transparent;
  cursor: pointer;
  font-size: 24px;
}
.Z854tH img {
  width: 16px;
  height: 16px;
}
.Z854tH:hover {
  background: var(--surface-neutral-subtle);
}
.h42nO0 {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--spacing-2);
}
.SqNWnP {
  margin: 0 0 var(--spacing-2);
  padding: var(--spacing-2);
  border-radius: var(--radius-m);
  background: var(--surface-neutral-subtle);
  font-size: var(--font-size-md);
}
.LawmQH {
  width: fit-content;
  max-width: 78%;
  padding: var(--spacing-1-5);
  margin-bottom: var(--spacing-2);
  border-radius: var(--radius-m);
  overflow-wrap: anywhere;
}
.LawmQH p {
  margin: var(--spacing-1) 0 0;
  white-space: pre-wrap;
}
.TG3Wg0 {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}
.WDl3K5 {
  margin-left: auto;
  color: var(--text-neutral-white);
  background: var(--surface-tertiary-strong);
}
.VQHCL4 {
  background: var(--surface-neutral-subtle);
}
.mbUxdJ {
  margin: 0;
  padding: var(--spacing-1) var(--spacing-2);
  color: var(--status-alert);
  background: var(--inline-error-background);
}
.T7gAjO {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: var(--spacing-1);
  padding: var(--spacing-2);
  border-top: 1px solid var(--stroke-neutral-subtle);
}

@media (max-width: 480px) {
  .d20XCF {
    bottom: var(--spacing-1);
    right: var(--spacing-1);
    width: calc(100vw - 16px);
    height: calc(100dvh - 16px);
  }
  .bFiumo {
    height: 56px;
  }
  .LawmQH {
    max-width: 90%;
  }
  .T7gAjO {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AssistantChat/AssistantChat.module.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iCAAiC;EACjC,gCAAgC;EAChC,yFAAyF;EACzF,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;;EAEE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,8BAA8B;EAC9B,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,qDAAqD;EACrD,8FAA8F;AAChG;;AAEA;EACE,OAAO;EACP,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,0CAA0C;EAC1C,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE;IACE,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".launcher,\n.panel {\n  position: fixed;\n  bottom: var(--spacing-3);\n  right: var(--spacing-3);\n  z-index: 1000;\n  box-shadow: var(--shadow-xl);\n  font-family: var(--font-family-base);\n}\n\n.launcher {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border: 0;\n  border-radius: var(--radius-pill);\n  color: var(--text-neutral-white);\n  background: linear-gradient(135deg, var(--surface-primary-medium), var(--data-series-06));\n  cursor: pointer;\n}\n\n.launcher[hidden] {\n  display: none;\n}\n.launcher:focus-visible,\n.control:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 3px;\n}\n\n.panel {\n  margin: 0;\n  padding: 0;\n  top: auto;\n  left: auto;\n  max-width: none;\n  max-height: none;\n  width: min(880px, calc(100vw - 48px));\n  height: min(680px, calc(100dvh - 48px));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-m);\n  color: var(--text-neutral-dark);\n  background: var(--surface-neutral-white);\n}\n\n.minimized {\n  width: min(360px, calc(100vw - 48px));\n  height: 56px;\n}\n.header {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  min-height: 56px;\n  padding: 0 var(--spacing-2);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  background: linear-gradient(90deg, var(--surface-tertiary-soft), var(--surface-neutral-white));\n}\n\n.header h2 {\n  flex: 1;\n  margin: 0;\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n}\n.assistantIcon {\n  display: inline-flex;\n  color: var(--surface-tertiary-strong);\n}\n.control {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: var(--radius-xs);\n  color: var(--text-neutral-dark);\n  background: transparent;\n  cursor: pointer;\n  font-size: 24px;\n}\n.control img {\n  width: 16px;\n  height: 16px;\n}\n.control:hover {\n  background: var(--surface-neutral-subtle);\n}\n.messages {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: var(--spacing-2);\n}\n.greeting {\n  margin: 0 0 var(--spacing-2);\n  padding: var(--spacing-2);\n  border-radius: var(--radius-m);\n  background: var(--surface-neutral-subtle);\n  font-size: var(--font-size-md);\n}\n.message {\n  width: fit-content;\n  max-width: 78%;\n  padding: var(--spacing-1-5);\n  margin-bottom: var(--spacing-2);\n  border-radius: var(--radius-m);\n  overflow-wrap: anywhere;\n}\n.message p {\n  margin: var(--spacing-1) 0 0;\n  white-space: pre-wrap;\n}\n.role {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n}\n.userMessage {\n  margin-left: auto;\n  color: var(--text-neutral-white);\n  background: var(--surface-tertiary-strong);\n}\n.assistantMessage {\n  background: var(--surface-neutral-subtle);\n}\n.error {\n  margin: 0;\n  padding: var(--spacing-1) var(--spacing-2);\n  color: var(--status-alert);\n  background: var(--inline-error-background);\n}\n.composer {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: end;\n  gap: var(--spacing-1);\n  padding: var(--spacing-2);\n  border-top: 1px solid var(--stroke-neutral-subtle);\n}\n\n@media (max-width: 480px) {\n  .panel {\n    bottom: var(--spacing-1);\n    right: var(--spacing-1);\n    width: calc(100vw - 16px);\n    height: calc(100dvh - 16px);\n  }\n  .minimized {\n    height: 56px;\n  }\n  .message {\n    max-width: 90%;\n  }\n  .composer {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"launcher": `vCQFCw`,
	"panel": `d20XCF`,
	"control": `Z854tH`,
	"minimized": `bFiumo`,
	"header": `q1S3fM`,
	"assistantIcon": `Ixg_XP`,
	"messages": `h42nO0`,
	"greeting": `SqNWnP`,
	"message": `LawmQH`,
	"role": `TG3Wg0`,
	"userMessage": `WDl3K5`,
	"assistantMessage": `VQHCL4`,
	"error": `mbUxdJ`,
	"composer": `T7gAjO`
};
module.exports = ___CSS_LOADER_EXPORT___;
